// Bootstraps ApiClient with a dynamic token provider and an auth-ready gate.
// Call initApiAuth() once at app entry, before any component renders.
import { supabase } from './supabase'
import { apiClient } from './api'

let currentToken: string | null = null
let resolveReady: (() => void) | undefined
const authReady = new Promise<void>(resolve => {
  resolveReady = resolve
})

function markReady(): void {
  resolveReady?.()
  resolveReady = undefined
}

export const READY_TIMEOUT_MS = 3000

let initialized = false

export function initApiAuth(): Promise<void> {
  if (initialized) return authReady
  initialized = true

  // Safety net: unblock requests after a timeout if no auth event fires.
  setTimeout(markReady, READY_TIMEOUT_MS)

  // Resolve on the FIRST event regardless of type.
  supabase.auth.onAuthStateChange((_event, session) => {
    currentToken = session?.access_token ?? null
    markReady()
  })

  apiClient.setTokenProvider(() => currentToken)
  apiClient.setAuthReady(authReady)

  return authReady
}

export { authReady }
